import getUrl from "@/Helpers/BaseUrl";
import axios from "axios";
export async function getEmployees() {
    const response = await axios.get(getUrl(`/api/CRM/${process.env.VUE_APP_API_VERSION}/Employee`));
    return response.data;
}
